import { ComposedTheme } from '@glu/theming';

const themeOverrides = ({ palette: { background, colors, text } }: ComposedTheme) => ({
  alerts: {
    positive: {
      backgroundColor: background,
      color: colors?.mineShaft || '#333333',
      borderColor: colors?.emerald || '#32C846',
      '& $alertIcon svg': {
        fill: colors?.emerald || '#32C846'
      }
    },
    negative: {
      backgroundColor: background,
      color: colors?.mineShaft || '#333333',
      borderColor: colors?.red || '#DF0000',
      '& $alertIcon svg': {
        fill: colors?.red
      }
    },
    warning: {
      backgroundColor: background,
      color: colors?.mineShaft || '#333333',
      borderColor: colors?.yellowOrange,
      '& $alertIcon svg': {
        fill: colors?.yellowOrange || '#FF9C46'
      }
    },
    info: {
      backgroundColor: background,
      color: colors?.mineShaft || '#333333',
      borderColor: colors?.dodgerBlue,
      '& $alertIcon svg': {
        fill: colors?.dodgerBlue || '#1FA2FF'
      }
    },
    btnDetails: {
      '&:focus, &:active': {
        backgroundColor: background
      }
    }
  },
  popover: {
    content: {
      backgroundColor: {
        defaultBackgroundColor: background
      },
      color: {
        negativeColor: text?.dark
      }
    }
  }
});

export default themeOverrides;
